require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[19],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(229);


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;

var _Decorator = _interopRequireWildcard(__webpack_require__(230));

exports["default"] = _Decorator["default"];
exports.Decorator = _Decorator["default"];
exports.Decoration = _Decorator.Decoration;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.Decoration = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _Decorator = _interopRequireDefault(__webpack_require__(231));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var decoratorClassName = _Decorator["default"].decoratorClassName.replace(/"/g, '');

var decorationClassName = _Decorator["default"].decorationClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

var Decorator = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Decorator, _Component);

  function Decorator() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Decorator.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style,
        className = _this$props.className,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["style", "className"]);
    return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, sanitize(others, Decorator), {
      className: decoratorClassName + " " + className,
      style: style
    }), this.props.children);
  };

  return Decorator;
}(_react.Component);

exports["default"] = Decorator;
(0, _defineProperty2["default"])(Decorator, "propTypes", {
  children: _propTypes["default"].node.isRequired,
  style: _propTypes["default"].object,
  className: _propTypes["default"].string
});
(0, _defineProperty2["default"])(Decorator, "defaultProps", {
  style: {},
  className: ''
});

var Decoration = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(Decoration, _Component2);

  function Decoration() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = Decoration.prototype;

  _proto2.render = function render() {
    var _cx;

    var _this$props2 = this.props,
        location = _this$props2.location,
        style = _this$props2.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["location", "style"]);
    var styles;

    if (location === 'point') {
      styles = (0, _extends2["default"])({
        left: this.props.x,
        top: this.props.y
      }, style);
    }

    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, Decoration), {
      className: (0, _utils.classnames)(decorationClassName, (_cx = {}, _cx[this.props.location] = 1, _cx)),
      style: styles
    }), this.props.children);
  };

  return Decoration;
}(_react.Component);

exports.Decoration = Decoration;
(0, _defineProperty2["default"])(Decoration, "propTypes", {
  children: _propTypes["default"].node.isRequired,
  location: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'point']),
  x: _propTypes["default"].number,
  y: _propTypes["default"].number,
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(Decoration, "defaultProps", {
  location: 'bottomRight',
  style: {}
});

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(232);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-decorator{position:relative;display:inline-block}.ba-common-decoration{position:absolute}.ba-common-decoration.is-point{transform:translateX(-50%) translateY(-50%)}.ba-common-decoration.is-left{top:50%;left:0;transform:translateX(-33%) translateY(-50%)}.ba-common-decoration.is-right{top:50%;right:0;transform:translateX(33%) translateY(-50%)}.ba-common-decoration.is-top{top:0;left:50%;transform:translateX(-50%) translateY(-33%)}.ba-common-decoration.is-bottom{bottom:0;left:50%;transform:translateX(-50%) translateY(33%)}.ba-common-decoration.is-topLeft{top:0;left:0;transform:translateX(-33%) translateY(-33%)}.ba-common-decoration.is-topRight{top:0;right:0;transform:translateX(33%) translateY(-33%)}.ba-common-decoration.is-bottomLeft{bottom:0;left:0;transform:translateX(-33%) translateY(33%)}.ba-common-decoration.is-bottomRight{bottom:0;right:0;transform:translateX(33%) translateY(33%)}\n", ""]);

// exports
exports.locals = {
	"decoratorClassName": "\"ba-common-decorator\"",
	"decorationClassName": "\"ba-common-decoration\""
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[228,0]]]);
});